/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
var A;!function(A){A[A.ELEVATION=0]="ELEVATION",A[A.MAP=1]="MAP"}(A||(A={}));const E=[A.ELEVATION,A.MAP];export{A as LayerClass,E as LayerClasses};
